import { inject } from '@angular/core';
import { forkJoin, switchMap, map, of, EMPTY } from 'rxjs';
import { SchoolSharedService } from './core/school/school.service';
import { UserSharedService } from './core/users/user.service';
import { Router } from '@angular/router';
import { Auth, signInWithCustomToken } from '@angular/fire/auth';

export const initialDataResolver = () => {
    const schoolService = inject(SchoolSharedService);
    const userService = inject(UserSharedService);
    const router = inject(Router);
    const auth = inject(Auth);

    console.log('Initial data resolver called');

    // Use the userCode set after login
    // Check for user code in localStorage
    const userCode = localStorage.getItem('userCode');
    const userRole = localStorage.getItem('userRole');
    if (!userCode) {
        router.navigate(['/login']);
        return EMPTY; // Prevents route activation
    }
    userService.userCode = userCode;
    // Ensure Firebase is signed in (anonymous) so Firestore rules allow reads
    if (!auth.currentUser) {
        userService.getFirebaseToken().subscribe({
            next: (token) => signInWithCustomToken(auth, token).catch(e => console.warn('Firebase sign-in failed:', e)),
            error: (e) => console.warn('Firebase token failed:', e)
        });
    }
    console.log('User code:', userCode);
    console.log('User role:', userRole);

    // 1. Load user details first
    return userService.getUserByCode(userCode).pipe(
        switchMap(userResponse => {

            console.log('User response:', userResponse);

            if (userRole === 'ADMIN' || userRole === 'STAFF') {
                // If the user is not an admin or superadmin, redirect to the dashboard
                const user = userResponse.data;
                
                // Try to get selected school code from localStorage
                let schoolCode = localStorage.getItem('selectedSchoolCode');

                // If not found or not in user's schools, fallback to first
                if (!schoolCode || !user?.staffSchoolRoles?.some(s => s.schoolCode === schoolCode)) {
                    schoolCode = (user?.staffSchoolRoles && user.staffSchoolRoles.length > 0 && user.staffSchoolRoles[0].schoolCode !== undefined)
                        ? user.staffSchoolRoles[0].schoolCode
                        : null;

                    

                    // Store selected school code in localStorage
                    if (schoolCode) {
                        localStorage.setItem('selectedSchoolCode', schoolCode);
                    }
                }

                console.log('Selected school code:', schoolCode);

                // 3. Load the default school details
                return forkJoin([
                    schoolService.getSchoolByCode(schoolCode || ''),
                    of(userResponse) // pass user details as well
                ]);
            } else if (userRole === 'super-admin') {
                console.log('Super Admin detected');
                const defaultSchool = [{ code: userCode, name: 'Super Admin' }];
                // Add to userResponse.data.schools as well
                if (userResponse.data) {
                    const staffSchoolRoles = 
                        [
                            {
                                id: 0,
                                staffCode: userCode,
                                schoolCode: 'super-admin',
                                schoolName: 'Super Admin',
                                role: 'super-admin',
                                status: 'active',
                                allowedClassroomCodes: []
                            }
                        ];
                    
                    userResponse.data.staffSchoolRoles = staffSchoolRoles;
                }
                return forkJoin([
                    of(defaultSchool),
                    of(userResponse)
                ]);
            } else {
                // For any other case, return EMPTY to satisfy Observable return type
                return EMPTY;
            }
        })
    );
};